module.exports = {"__schema":{"types":[{"kind":"INTERFACE","name":"BeanConnection","possibleTypes":[{"name":"Account"},{"name":"UserInfo"}]},{"kind":"UNION","name":"UserInfoRecord","possibleTypes":[{"name":"PatientRecord"},{"name":"AssigneeRecord"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./src/fragmentTypes.json
// module id = 643
// module chunks = 0